"use client";
import { useTheme } from "next-themes";
import type React from "react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme === "light" || theme === "dark" || theme === "system" ? theme : "system"}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-raised group-[.toaster]:text-gray-12 group-[.toaster]:shadow-floating group-[.toaster]:rounded-xl! group-[.toaster]:font-sans",
          title: "group-[.toast]:font-medium",
          description: "group-[.toast]:text-gray-11!",
          actionButton:
            "group-[.toast]:bg-gray-12! group-[.toast]:text-gray-1! group-[.toast]:rounded-md! group-[.toast]:font-medium",
          cancelButton:
            "group-[.toast]:bg-grayA-3! group-[.toast]:text-gray-11! group-[.toast]:rounded-md!",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
